export default __webpack_public_path__ + "static/media/switch-badge-icon.c8b168c9.svg";